import { gql } from "@apollo/client";
import { COURSE_FRAGMENT, SERIES_FRAGMENT } from "../fragments";

export const UPDATE_AUTH_USER_DETAILS = gql`
  ${COURSE_FRAGMENT}
  ${SERIES_FRAGMENT}
  mutation UpdateAuthUserDetails(
    $firstName: String!
    $lastName: String!
    $mobileNumber: String!
    $locationId: Int!
    $refUrl: String!
  ) {
    userUpdate(
      input: {
        firstName: $firstName
        lastName: $lastName
        mobileNumber: $mobileNumber
        locationId: $locationId
        refUrl: $refUrl
      }
    ) {
      firstName
      lastName
      mobileNumber
      location {
        id
        name
        parent {
          name
        }
      }
      activeCart {
        uuid
        discountAmount
        subTotalAmount
        nsdcAmount
        totalAmount
        taxAmount
        cartItems {
          uuid
          discountAmount
          subTotalAmount
          totalAmount
          itemable {
            __typename
            ...CourseFragment
            ...SeriesFragment
          }
          nsdcIncluded
          nsdcPrice
          nsdcOrignalPriceCart
        }
        coupon {
          code
          description
          discount
        }
      }
    }
  }
`;

export const UPDATE_PROFILE_USER_DETAILS = gql`
  mutation UpdateProfileUserDetails($updateInput: UpdateInput!) {
    userUpdate(input: $updateInput) {
      firstName
      lastName
      mobileNumber
      dateOfBirth
      college
      profilePicture {
        filename
        url
      }
      location {
        id
        name
        parent {
          name
        }
      }
    }
  }
`;
